// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qf7me{padding:0 48px}.UrG0_{position:absolute;bottom:48px}.lHPGI{min-width:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textContent": `qf7me`,
	"ctaWrapper": `UrG0_`,
	"ctaButton": `lHPGI`
};
export default ___CSS_LOADER_EXPORT___;
